import { Color, Spacing, Text } from '@billy/design-system'
import styled from '@emotion/styled'
import React from 'react'

import * as Styled from './styles'
import { SmartSelectItem } from './types'

const HeadingWrapper = styled.header`
  margin: -${Spacing.S8} 0 -${Spacing.S8} -${Spacing.S8};
`

export type SelectListItemProps = SmartSelectItem

export const SelectListItem = ({
  children,
  css: providedCSS,
  description,
  id,
  isHeading,
  onItemSelect = (id: string) => id,
  selectedId,
  text,
  withFooter,
  ...rest
}: SelectListItemProps) => {
  const selected = isHeading ? false : selectedId === id

  let content

  if (isHeading) {
    content = (
      <HeadingWrapper>
        <Text variant="bodySM" colorVariant="secondary" uppercase>
          {text}
        </Text>
      </HeadingWrapper>
    )
  } else if (description) {
    content = (
      <>
        <Text weight="medium" color={selected ? Color.Lavender500 : undefined}>
          {text}
        </Text>
        <Text variant="bodySM" color={selected ? Color.Lavender500 : Color.Grey500}>
          {description}
        </Text>
      </>
    )
  } else {
    content = (
      <Text weight="medium" color={selected ? Color.Lavender500 : undefined}>
        {text}
      </Text>
    )
  }

  const handleRowSelect = () => (isHeading ? null : onItemSelect(id))

  return (
    <Styled.SelectListItemWrapper
      isHeading={isHeading}
      selected={selected}
      onClick={handleRowSelect}
      withFooter={withFooter}
    >
      {children || content}
    </Styled.SelectListItemWrapper>
  )
}
